import { render, staticRenderFns } from "./TwoFactorProtection.vue?vue&type=template&id=760da10a&scoped=true"
import script from "./TwoFactorProtection.vue?vue&type=script&lang=js"
export * from "./TwoFactorProtection.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorProtection.vue?vue&type=style&index=0&id=760da10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760da10a",
  null
  
)

export default component.exports